import React, { useState, useEffect, useRef } from 'react';

interface TypeWriterProps {
  text: string;
  typingSpeed?: number;
  erasingSpeed?: number;
  delayBeforeErasing?: number;
}

const TypeWriter: React.FC<TypeWriterProps> = ({
                                                 text,
                                                 typingSpeed = 50,
                                                 erasingSpeed = 30,
                                                 delayBeforeErasing = 5000
                                               }) => {
  const [displayText, setDisplayText] = useState('');
  const isMountedRef = useRef(true);
  const timeoutRef = useRef<NodeJS.Timeout>();

  // Безопасная установка состояния
  const safeSetDisplayText = (text: string) => {
    if (isMountedRef.current) {
      setDisplayText(text);
    }
  };

  useEffect(() => {
    let currentIndex = 0;
    let isErasing = false;

    const updateText = () => {
      if (!isMountedRef.current) return;

      if (!isErasing) {
        // Typing phase
        if (currentIndex <= text.length) {
          safeSetDisplayText(text.substring(0, currentIndex));
          currentIndex++;
          timeoutRef.current = setTimeout(updateText, typingSpeed);
        } else {
          // Start waiting before erasing
          timeoutRef.current = setTimeout(() => {
            if (!isMountedRef.current) return;
            isErasing = true;
            updateText();
          }, delayBeforeErasing);
        }
      } else {
        // Erasing phase
        if (currentIndex > 0) {
          currentIndex--;
          safeSetDisplayText(text.substring(0, currentIndex));
          timeoutRef.current = setTimeout(updateText, erasingSpeed);
        } else {
          // Reset for next cycle
          isErasing = false;
          currentIndex = 0;
          timeoutRef.current = setTimeout(updateText, typingSpeed);
        }
      }
    };

    // Установка начального состояния
    isMountedRef.current = true;
    // Запуск анимации
    updateText();

    // Очистка при размонтировании
    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [text, typingSpeed, erasingSpeed, delayBeforeErasing]);

  return (
      <div className="mx-auto text-center text-base whitespace-pre-wrap break-all mt-0.5"
           style={{ color: 'rgb(255, 255, 255)' }}>
        {displayText}
        <span className="animate-blink">|</span>
      </div>
  );
};

export default TypeWriter;